/* eslint-disable no-unused-vars */
export const API_URL = process.env.REACT_APP_API_URL || '';

export enum ApiPath {
  LOGIN = '/api/auth/login',

  // Admin
  ADMIN_FORGOT_PASSWORD = '/api/auth/admin/forgot-password',
  ADMIN_CHECK_RESET_TOKEN = '/api/auth/admin/check-reset-token',
  ADMIN_RESET_PASSWORD = '/api/auth/admin/reset-password',

  // Customer
  CUSTOMER_FORGOT_PASSWORD = '/api/auth/customer/forgot-password',
  CUSTOMER_RESET_PASSWORD = '/api/auth/customer/reset-password',
  CUSTOMER_CHECK_RESET_TOKEN = '/api/auth/customer/check-reset-token',
  CUSTOMER_LOGIN = '/api/auth/customer/login',
  CUSTOMER_LOGIN_OTP = '/api/auth/customer/login-otp',
  CUSTOMER_VERIFY_OTP = '/api/auth/customer/login-otp/verify-otp',
  CUSTOMER_RESEND_OTP = '/api/auth/customer/login-otp/resend-otp',

  // User/Profile
  CUSTOMER_GET_ME = '/api/customer/me',
  CUSTOMER_AVATAR = '/api/customer/avatar',
  ADMIN_GET_ME = '/api/admin',

  // ADMIN - USER / CLIENT / AGENCY / CUSTOMER
  ADMIN_USERS = '/api/admin/users',
  ADMIN_USERS_BASIC_INFO = '/api/admin/users/basic-info',
  ADMIN_POSITIONS = '/api/admin/positions',

  ADMIN_CLIENTS = '/api/admin/clients',
  CLIENT_CHECK_EMAIL = '/api/admin/clients/check-email',

  ADMIN_AGENCY = '/api/admin/agencies',
  ADMIN_AGENCY_BASIC = '/api/admin/agencies/basic',
  ADMIN_AGENCY_AUTHORITY = '/api/admin/agency-authorities',

  ADMIN_CUSTOMERS = '/api/admin/customers',
  ADMIN_CUSTOMERS_BASIC_INFO = '/api/admin/customers/basic-info',
  ADMIN_CUSTOMER_DETAIL = '/api/admin/customers/detail',
  EDIT_HISTORY = '/info-histories',

  // PRODUCT (Maker / Model / Category)
  // Public
  PUBLIC_MAKERS = '/api/public/makers',
  PUBLIC_PRODUCT_MODELS = '/api/public/product-models',
  PUBLIC_PRODUCT_CATEGORIES = '/api/public/product-categories',

  // Admin
  ADMIN_PRODUCT_CATEGORIES = '/api/admin/product-categories',
  ADMIN_PRODUCT_MODELS = '/api/admin/product-models',
  ADMIN_MAKERS = '/api/admin/makers',

  // AGREEMENT / CONTRACT
  // Public
  PUBLIC_AGREEMENTS = '/api/public/agreements',
  PUBLIC_CONTRACT_DETAIL = 'api/public/customer-contracts',

  // Customer
  CUSTOMER_AGREEMENTS = '/api/customer/agreements',
  CUSTOMER_AGREEMENT_HISTORY = '/api/customer/customer-history',

  // QR / Contract template
  QR_CODES = '/api/admin/contract-templates',
  PUBLIC_QR_CODES_DETAIL = '/api/public/contract-templates/qr',

  // IMEI
  // Public
  PUBLIC_IMEI = '/api/public/submit-imeis',
  PUBLIC_CONFIRM_IMEI = '/api/public/imeis',

  // Customer
  CUSTOMER_IMEI = '/api/customer/submit-imeis',
  CUSTOMER_IMEI_DETAIL = '/api/customer/imeis',
  CUSTOMER_NOT_READ_IMEI_COUNT = '/api/customer/submit-imeis/count-not-yet-read',

  // Admin
  ADMIN_IMEIS = '/api/admin/imeis',
  IMEI_FILES = '/imei-files',

  // REPAIR
  // Public
  PUBLIC_REPAIRS = '/api/public/repairs',
  DOWNLOAD_PDF_FILE = '/api/public/repairs/download',

  // Customer
  CUSTOMER_REPAIRS = '/api/customer/repairs',

  // Admin
  ADMIN_REPAIRS = '/api/admin/repairs',
  ADMIN_REPAIRS_AGREEMENTS = '/api/admin/repair-agreements',

  // Route
  REPAIR = '/repair',
  STATUS = '/status',
  CONFIRM = '/confirm',
  CANCEL = '/cancel',
  ADMIN_CANCEL = '/admin-cancel',

  // PAYMENT / TRANSACTION
  PUBLIC_VALIDATE_PAYMENT_LINK = '/api/public/validate-payment-link',
  CHECK_PAYMENT_STATUS = '/api/payment/check-result',
  CUSTOMER_PAYMENT_HISTORY = '/api/customer/payment-transactions',
  PAYMENT_TRANSACTIONS = '/api/admin/payment-transactions/sumary',
  PAYMENT_TRANSACTIONS_ONLY = '/payment-transactions',
  PAYMENT_TRANSACTIONS_EXPORT_CSV = '/api/admin/payment-transactions/export-csv',

  //PLAN / SUBSCRIPTION
  // Public
  PUBLIC_PLANS = '/api/public/plans',
  PUBLIC_PLAN_SUBSCRIPTION = '/api/public/customer-plan-subscriptions',
  PUBLIC_DETAIL_SUBSCRIPTION = 'api/public/customer-plan-subscriptions',

  // Customer
  CUSTOMER_PLAN_SUBSCRIPTIONS = '/api/customer/customer-plan-subscriptions',

  // Plans
  ADMIN_PLANS = '/api/admin/plans',
  PRIVATE_PLANS = '/api/admin/plans/basic',
  ADMIN_PLANS_SUPPLEMENTARY = '/api/admin/plans/supplementary',
  ADMIN_PLAN_SUBSCRIPTIONS = '/api/admin/customer-plan-subscriptions',
  WARRANTY = '/warranty',

  // SALES
  ADMIN_SALES = '/api/admin/sales',
  ADMIN_SALES_SUMMARY = '/api/admin/sales/summary',
  ADMIN_SALE_EXPORT_CSV = '/api/admin/sales/export-csv',

  // FILE / IMPORT / EXPORT
  PUBLIC_FILES = '/api/public/files',
  DOCUMENTS = '/documents',
  CSV = '/csv',
  ADMIN_IMPORT_CSV_FILE = '/api/admin/import',

  // NOTIFICATION / COUNT
  CUSTOMER_NOT_READ_AGREEMENT_COUNT = '/api/customer/insurance-claim-agreements/count-agreement-not-yet-read',

  // DASHBOARD / STATISTICS
  ADMIN_DASHBOARD_OVERVIEW = '/api/admin/dashboard/overview',
  ADMIN_DASHBOARD_BILLING_TYPE_SALES = '/api/admin/dashboard/billing-revenue',
  ADMIN_DASHBOARD_ACTIVE_SUBSCRIPTION = '/api/admin/dashboard/subscription-members',
  ADMIN_DASHBOARD_ONE_TIME_TRANSACTION = '/api/admin/dashboard/shot-transactions',
  ADMIN_CALL_STATISTICS = '/api/admin/call-statistics',
  ADMIN_REPAIR_STATISTICS = '/api/admin/repair-statistics',

  // OTHER
  PUBLIC_CLIENTS_INFO = '/api/public/clients/info',

  // CUSTOM MAIL
  CUSTOM_EMAIL = '/api/admin/plan-emails',
  SEND_TEST = '/api/admin/plan-emails/send-test',
  DEFAULT_TEMPLATE = '/api/admin/plan-emails/default-template'
}
